import axiosCall from './interceptor';
import URL from '../helper';

export const generateTextFromPrompt = async data => {
  const url = `${URL.BASE_URL}generate/ruleText`;
  const resData = await axiosCall('post', url, {
    prompt: data,
  });
  return resData.data;
};

export const getBusinessLogics = async documentId => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/businessLogic?id=${documentId}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const updateBusinessLogic = async payload => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/businessLogic`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};

export const deleteBusinessLogic = async payload => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/businessLogic`;
  let response = await axiosCall('delete', url, payload);
  return response.data;
};

export const updateEmailBusinessLogic = async payload => {
  const url = `${URL.DESIGN_SYSTEM_URL}emailTemplate/businessLogic`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};

export const deleteEmailBusinessLogic = async payload => {
  const url = `${URL.DESIGN_SYSTEM_URL}emailTemplate/businessLogic`;
  let response = await axiosCall('delete', url, payload);
  return response.data;
};

export const getEmailBusinessLogics = async documentId => {
  const url = `${URL.DESIGN_SYSTEM_URL}emailTemplate/businessLogic?id=${documentId}`;
  let response = await axiosCall('get', url);
  return response.data;
};

